<div
  class="d-flex flex-row align-items-center"
  [attr.data-status]="status"
  [attr.data-result]="result"
>
  <div *ngIf="circStatus != 'InCreation'">
    <step-result-icon
      [result]="result"
      [title]="result | i18nStepResult"
    ></step-result-icon>
    <step-status-icon
      *ngIf="status !== 'Finished'"
      [status]="status"
      [title]="status | i18nStepStatus"
    ></step-status-icon>
    <span class="pl-sm-1" *ngIf="status !== 'Finished'">{{
      status | i18nStepStatus
    }}</span>
    <span class="pl-sm-1" *ngIf="status === 'Finished'">{{
      result | i18nStepResult
    }}</span>
  </div>
  <div *ngIf="circStatus == 'InCreation'">
    @if(hasErrors){
      <div kendoTooltip>
        <kendo-icon name="warning" themeColor="warning" [title]="'step_has_errors' | i18n"></kendo-icon>
      </div>
    }
  </div>
</div>
